// extracted by mini-css-extract-plugin
module.exports = {"title":"Burn_title__2sHCK","text":"Burn_text__rIvgU","info":"Burn_info__3ZOoj","input":"Burn_input__18YVp","btns":"Burn_btns__OyrRl","button":"Burn_button__23xGV"};